import React from 'react';
import { XIcon } from 'lucide-react';
import { WalletSection } from './WalletSection';
interface WalletBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}
export function WalletBottomSheet({
  isOpen,
  onClose
}: WalletBottomSheetProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-end" data-id="element-1246" data-mp="10688evvpdqgr">
      <div className="bg-white rounded-t-xl w-full max-h-[90vh] overflow-y-auto" data-id="element-1247" data-mp="10458nk4r0iyu">
        <div className="sticky top-0 bg-white border-b border-gray-200 flex items-center justify-between p-4 z-10" data-id="element-1248" data-mp="147tik9gurqn9">
          <h2 className="text-lg font-bold" data-id="element-1249" data-mp="194to8j9sirdu">My Wallet</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-1250" data-mp="1dz7mqujr1emq">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-1251" data-mp="1iw7r910ya9bq" />
          </button>
        </div>
        <div className="p-4" data-id="element-1252" data-mp="1nxnf10uiitxt">
          <WalletSection data-id="element-1253" data-mp="1nu99xkugs6mo" />
        </div>
      </div>
    </div>;
}